import * as actionTypes from '../actions/actionTypes'

const initialState = {
    reports_period: '',
    patients_report_data: { 'therapists': [], 'patients': [] },
    visits_report_data: { 'reports': [] },
    action_bar_opened: false,
    loading_data: false,
    selected_visit_ids: []
}

const reportsReducer = (state = initialState, action) => {
    switch (action.type) {
        // NEW APPROACH
        case actionTypes.SET_REPORTS_PERIOD:
            return {
                ...state,
                reports_period: action.payload
            };
        case actionTypes.TOGGLE_REPORTS_ACTION_BAR:
            return {
                ...state,
                action_bar_opened: !state.action_bar_opened
            };
        case actionTypes.START_LOADING_DATA:
            return {
                ...state,
                loading_data: true
            };
        case actionTypes.SET_VISITS_IDS_FOR_REPORTS:
            return {
                ...state,
                selected_visit_ids: action.payload
            };
        case actionTypes.LOAD_VISITS_REPORT_DATA_SUCCEED:
            return {
                ...state,
                visits_report_data: action.payload,
                loading_data: false
            };
        case actionTypes.LOAD_PATIENTS_REPORT_DATA_SUCCEED:

            return {
                ...state,
                patients_report_data: action.payload,
                loading_data: false
            };
        default:
            return state
    }
};

export default reportsReducer



// WEBPACK FOOTER //
// ./src/store/reducers/reports.js